import {useParams} from "react-router-dom";
import { GalleryComponent } from "../../components/3d/gallery";
import { Instructions } from "../../components/organisms/Instructions";
import { ButtonContainer } from "../../components/organisms/ButtonContainer";
import { useState } from "react";
import { OfflineModeState } from "../../offline/offline.types";

export const GallerySpace = () => {
  const {id} = useParams();
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [offlineModeState, setOfflineModeState] = useState<OfflineModeState>({
    status: "online",
    isOffline: false,
    cachedGallery: null,
    message: null,
  });

  return (
    <>
      <div>
        <div className={id === "hexa" ? "col-md-9" : ""}>
          <GalleryComponent 
            feedbackModalOpen={feedbackModalOpen}
            onOfflineModeChange={setOfflineModeState}
          />
          <ButtonContainer 
            showFeedback={!offlineModeState.isOffline && offlineModeState.status !== "unavailable"}
            onFeedbackModalChange={setFeedbackModalOpen}
          />
          {offlineModeState.status !== "unavailable" && <Instructions />}
        </div>
      </div>
    </>
  );
};
